if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0;

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick();

    //fancybox
    $('.fancybox-copy').fancybox({
        wrapCSS : 'full-fancy-copy'
    });

    //animations below
    const animateHTML = function () {
        let elems,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        };
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            }
        };
        return {
            init: init
        }
    };
    animateHTML().init();
   //end animations

    $(window).scroll(function(){
        var scroll_top = $(document).scrollTop();
        if(scroll_top > 0) {
            $('.header__top-section').addClass('down');
        } else {
            $('.header__top-section').removeClass('down');
        }

        console.log($(document).height() + ' ,' + ($(document).height() - 150));

        if(scroll_top >= ($(document).height() - 150)) {
            $('.header__open-table').addClass('test');
        } else {
            $('.header__open-table').removeClass('test');
        }
    });

   window.onload = function(){
       scrollW();
       window.addEventListener('scroll', function(){
           scrollW();
       })
   }
   function scrollW(){
       let st = window.pageYOffset || document.documentElement.scrollTop;
       if(st > 0){
           if (st > lastScrollTop){
               // downscroll code
               if(!document.getElementById('header').classList.contains('down')){
                   document.getElementById('header').classList.add('down');
                   document.getElementById('header').classList.remove('up');
               }
           } else {
               // upscroll code
               if(!document.getElementById('header').classList.contains('up')){
                   document.getElementById('header').classList.add('up');
                   document.getElementById('header').classList.remove('down');
               }
           }
       } else {
           if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
               document.getElementById('header').classList.remove('up');
               document.getElementById('header').classList.remove('down');
           }
       }
       lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
   }

    if(window.location.hash){
        // smooth scroll to the anchor id
        $('html,body').animate({
            scrollTop:$(window.location.hash).offset().top + 'px'
        },800,'swing');
    }

    if(document.getElementById('home')){
        let menuUrl = document.querySelector('.primary-nav-1 a').getAttribute('href').substring(1);
        document.querySelector('.primary-nav-1 a').setAttribute('href',menuUrl);
        //console.log(menuUrl);
        $("a:not(.fancybox-copy)").on('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault();
                var hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                    }, 800, function(){
                    window.location.hash = hash;
                });
                return false;
            } 
        });
    }

})();